export const MASTER_ELEMENTS_CATEGORIES = {
  TEXT_CATEGORY_LABEL: { key: 'TEXT_CATEGORY_LABEL', value: 'Text' },
  LINE_CATEGORY_LABEL: { key: 'LINE_CATEGORY_LABEL', value: 'Line' },
  BARCODE_CATEGORY_LABEL: { key: 'BARCODE_CATEGORY_LABEL', value: 'Barcode' },
  SHAPE_CATEGORY_LABEL: { key: 'SHAPE_CATEGORY_LABEL', value: 'Shape' },
  FORM_CATEGORY_LABEL: { key: 'FORM_CATEGORY_LABEL', value: 'Form' },
  TABLE_CATEGORY_LABEL: { key: 'TABLE_CATEGORY_LABEL', value: 'Table' },
  CHART_CATEGORY_LABEL: { key: 'CHART_CATEGORY_LABEL', value: 'Charts' },
};

// freehand text

export const FREE_HAND_TEXT_ELEMENTS = {
  HEADING: {
    key: 'HEADING',
    value:
      '<p style="font-family: Open Sans; font-size: 72px; line-height: 1.5em;"><strong style="letter-spacing:0px; font-weight:700; color: rgb(0, 0, 0);">Add a title</strong></p>',
  },
  HEADING_TEXT: {
    key: 'HEADING_TEXT',
    value: 'Add a title'
  },
  HEADING_THUMBNAIL: {
    key: 'HEADING_THUMBNAIL',
    value:
      '<p style="font-family: Open Sans; font-size: 34px; line-height: 1.25em;"><strong style="letter-spacing:0px; font-weight:700; color: rgb(0, 0, 0);">Add a title</strong></p>',
  },
  SUB_HEADING: {
    key: 'SUB_HEADING',
    value:
      '<p style="font-size: 42px; font-family: Open Sans; line-height: 1.5em;"><strong style="letter-spacing:0px; color: rgb(0, 0, 0); font-weight: 700;">Add a subtitle</strong></p>',
  },
  SUB_HEADING_TEXT: {
    key: 'SUB_HEADING_TEXT',
    value:
      'Add a subtitle',
  },
  SUB_HEADING_THUMBNAIL: {
    key: 'SUB_HEADING_THUMBNAIL',
    value:
      '<p style="font-size: 24px; font-family: Open Sans; line-height: 1.25em;"><strong style="letter-spacing:0px; color: rgb(0, 0, 0); font-weight: 700;">Add a subtitle</strong></p>',
  },
  BODY: {
    key: 'BODY',
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(0, 0, 0); ">Add a bit of content to template</span></p>',
  },
  BODY_TEXT: {
    key: 'BODY_TEXT',
    value:
      'Add a bit of content to template',
  },
  BODY_THUMBNAIL: {
    key: 'BODY_THUMBNAIL',
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(0, 0, 0); ">Add a bit of content to template</span></p>',
  },
  PARAGRAPH: {
    key: 'PARAGRAPH',
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 16px; line-height: 1.5em;"><span style="letter-spacing:0px; color: rgb(0, 0, 0);">Add a paragraph which is a group of sentences that fleshes out a single idea. In order for a paragraph to be effective, it must begin with a topic sentence, have sentences that support the main idea of that paragraph, and maintain a consistent flow.</span></p>',
  },
  PARAGRAPH_TEXT: {
    key: 'PARAGRAPH_TEXT',
    value:
      'Add a paragraph which is a group of sentences that fleshes out a single idea. In order for a paragraph to be effective, it must begin with a topic sentence, have sentences that support the main idea of that paragraph, and maintain a consistent flow.',
  },
  PARAGRAPH_THUMBNAIL: {
    key: 'PARAGRAPH_THUMBNAIL',
    value:
      '<p style="font-family: &quot;Open Sans&quot;; font-size: 8px; line-height: 1.25em;"><span style="letter-spacing:0px; color: rgb(0, 0, 0);">Add a paragraph which is a group of sentences that fleshes out a single idea. In order for a paragraph to be effective, it must begin with a topic sentence, have sentences that support the main idea of that paragraph, and maintain a consistent flow.</span></p>',
  },
};

export const TABLE_ELEMENTS = {
  STATIC_TABLE_LABEL : {
    key : 'STATIC_TABLE_LABEL',
    value: 'Static Table'
  },
  STATIC_TABLE_THUMBNAIL : {
    key : 'STATIC_TABLE_THUMBNAIL',
    value: `<table width="100%"  style='border-collapse:collapse;border:1px solid;'>
    <tr>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td>&nbsp;</td>
      <td rowspan="2">&nbsp;</td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>
  </table>`
  }
}

export const FILLABLE_ELEMENTS = {
  SIGNATURE_LABEL: { key: 'SIGNATURE_LABEL', value: 'Signature' },
  SIGNATURE_THUMBNAIL: {
    key: 'SIGNATURE_THUMBNAIL',
    value: `<div style="display: flex; align-items: center; justify-content: center;">
        <p style="font-family: Dancing Script;font-size: 15px !important;padding: 20px 30px !important;background: #fff;border: 3px solid #000;">Sign here</p>
      </div>`,
  },
  RADIO_BUTTON_LABEL: { key: 'RADIO_BUTTON_LABEL', value: 'Radio Buttons' },
  RADIO_BUTTON_THUMBNAIL: {
    key: 'RADIO_BUTTON_THUMBNAIL',
    value: `<div style="display: flex; align-items: center; justify-content: center;">
    <svg width="24" height="24" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
      <path d="M499 291q-56 0-104 28t-76 76-28 104 28 104 76 76 104 28 104-28 76-76 28-104-28-104-76-76-104-28zm0-208q-113 0-210 57-94 55-149 149-57 97-57 210t57 210q55 94 149 149 97 57 210 57t210-57q94-55 149-149 57-97 57-210t-57-210q-55-94-149-149-97-57-210-57zm0 749q-90 0-168-46-75-44-119-119-46-78-46-168t46-168q44-75 119-119 78-46 168-46t168 46q75 44 119 119 46 78 46 168t-46 168q-44 75-119 119-78 46-168 46z" />
    </svg> 
    <p class="fillableThumbnail">Radio Button</p>
  </div>`,
  },
  CHECK_BOX_LABEL: { key: 'CHECK_BOX_LABEL', value: 'Check Boxes' },
  CHECK_BOX_THUMBNAIL: {
    key: 'CHECK_BOX_THUMBNAIL',
    value: `<div style="display: flex; align-items: center; justify-content: center;">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Free-Icons"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <g
              transform="translate(-747.000000, -526.000000)"
              id="Group"
              stroke="#000000"
              strokeWidth={2}
            >
              <g transform="translate(745.000000, 524.000000)" id="Shape">
                <path d="M5.16000009,3 L18.8399999,3 C20.032935,3 21,3.96706498 21,5.16000009 L21,18.8399999 C21,20.032935 20.032935,21 18.8399999,21 L5.16000009,21 C3.96706498,21 3,20.032935 3,18.8399999 L3,5.16000009 C3,3.96706498 3.96706498,3 5.16000009,3 Z" />
                <polyline points="7 11.5593959 11.1176466 15.5 17 8.5" />
              </g>
            </g>
          </g>
        </svg>
        <p class="fillableThumbnail">Check Box</p>
      </div>
    `,
  },
  TEXT_BOX_LABEL: { key: 'TEXT_BOX_LABEL', value: 'Text box' },
  TEXT_BOX_THUMBNAIL: {
    key: 'TEXT_BOX_THUMBNAIL',
    value: `<div style="display: flex; align-items: center; justify-content: center;">
        <p style="font-size: 12px; font-weight: 600; padding: 5px 30px 5px 5px !important; background: rgb(231,229,229); font-family: Open Sans;">Placeholder Text</p>
      </div>`,
  },
  COMBO_BOX_LABEL: { key: 'COMBO_BOX_LABEL', value: 'Combo box' },
  COMBO_BOX_THUMBNAIL: {
    key: 'COMBO_BOX_THUMBNAIL',
    value: `
      <div style="display: flex; align-items: center; justify-content: center; padding: 0 5px 0 10px; background: #fff; border: 3px solid rgb(231,229,229);">
        <p class="comboBox">Select a value</p>
        <svg
          fill="#000000"
          width="24"
          height="24"
          viewBox="0 0 24 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{'dropdown'}</title>
          <path d="M18.813 11.406l-7.906 9.906c-0.75 0.906-1.906 0.906-2.625 0l-7.906-9.906c-0.75-0.938-0.375-1.656 0.781-1.656h16.875c1.188 0 1.531 0.719 0.781 1.656z" />
        </svg>
      </div>
    `,
  },
  COMBO_BOX_VALUE: { key: 'COMBO_BOX_VALUE', value: 'Combo box value' },
  CHECKBOX_GROUP_LABEL: { key: 'CHECKBOX_GROUP_LABEL', value: 'checkbox group' },
  RADIOBUTTON_GROUP_LABEL: { key: 'RADIOBUTTON_GROUP_LABEL', value: 'radiobutton group' },
  COMBOBOX_GROUP_LABEL: { key: 'COMBOBOX_GROUP_LABEL', value: 'combobox group' },
};

export const BARCODE_MASTER_ELEMENTS = {
  BARCODE_PDF_LABEL: { key: 'BARCODE_PDF_LABEL', value: 'barcodepdf417' },
  QRCODE_LABEL: { key: 'QRCODE_LABEL', value: 'qrCode' },
  DATAMATRIX_LABEL: { key: 'DATAMATRIX_LABEL', value: 'Datamatrixbarcode' },
  AZTEC_LABEL: { key: 'AZTEC_LABEL', value: 'AZTECbarcode' },
};

export const LINE_MASTER_ELEMENTS = {
  DOTTED_LINE_LABEL: { key: 'DOTTED_LINE_LABEL', value: 'Dottedline' },
  DASHED_LINE_LABEL: { key: 'DASHED_LINE_LABEL', value: 'dashedLine' },
  DOUBLE_LINE_LABEL: { key: 'DOUBLE_LINE_LABEL', value: 'doubleLine' },
  LINE_LABEL: { key: 'LINE_LABEL', value: 'line' },
};

export const SHAPES_MASTER_ELEMENTS = {
  SQUARE_LABEL: { key: 'SQUARE_LABEL', value: 'Square' },
  BORDERED_RECTANGLE_LABEL: { key: 'BORDERED_RECTANGLE_LABEL', value: 'Bordered Rectangle' },
  ROUNDED_RECTANGLE_LABEL: { key: 'ROUNDED_RECTANGLE_LABEL', value: 'Rounded Rectangle' },
  RECTANGLE_LABEL: { key: 'RECTANGLE_LABEL', value: 'Rectangle' },
  CIRCLE_LABEL: { key: 'CIRCLE_LABEL', value: 'Circle' },
};

export const CHARTS_MASTER_ELEMENTS = {
  PIE_CHART: { key: 'PIE_CHART', value: 'Pie Chart' },
  DONUT_CHART: { key: 'DONUT_CHART', value: 'Donut Chart' },
  BAR_CHART: { key: 'BAR_CHART', value: 'Bar Chart' },
  LINE_CHART: { key: 'LINE_CHART', value: 'Line Chart' },
};
